    import blalicon from "../assets/images/drblal-icon.png"; 
    import lalpath from "../assets/images/drlalpath-icon.png"; 
    import careathome from "../assets/images/careathome-icon.png"; 

    const BlabData = [
        {
            id:1,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:2,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:3,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:4,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:5,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:6,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:7,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },
         {
            id:8,
            image:blalicon,
            image2:lalpath,
            image3:careathome,
            offer:"25% Off",
            testname:"HbA1c Test (HemoglobinA1c)",
            moretest:"Includes 3 tests",
            time:"Reports in 7 Hrs",
            prices:"₹420",
            oldprices:"(₹999)",
            addbtn:"+ Add"
        },

    ]

    export default BlabData;